import { SubscriptionFormBlockKind } from '@mssgme/shared';
import { useModalThemes } from './useModalThemes';
import { useCustomInputTheme } from './useCustomInputTheme';

export const useInputTheme = () => {
    const { theme } = useModalThemes(SubscriptionFormBlockKind);

    return useCustomInputTheme(theme);
};
